import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 80px;
  padding: 10px;
  background-color: #2f2f2f;
  text-align: center;
  color: white;
  border-bottom-left-radius: 20px;
  & svg {
    width: 60px;
    height: 60px;
  }
`;
